window.convertYotpoPicturesWidget = (() => {
  'use strict';

  const WIDGET_SELECTOR = '.yotpo-pictures-widget';
  const HIDDEN_CLASS = 'convert-yotpo-pictures-widget--hidden';

  const getWidgets = () => document.querySelectorAll(WIDGET_SELECTOR);

  const emitEvent = (productId) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'yotpo_ugc_visible',
      product_id: productId,
    });
  };

  const observeWidgets = () => {
    getWidgets().forEach((widget) => {
      const productId = widget.dataset.productId;
      if (!productId) return;

      if (widget.children.length > 0) {
        emitEvent(productId);
        return;
      }

      const observer = new MutationObserver((_mutations, obs) => {
        if (widget.children.length > 0) {
          emitEvent(productId);
          obs.disconnect();
        }
      });

      observer.observe(widget, { childList: true, subtree: true });
    });
  };

  const control = () => {
    getWidgets().forEach((widget) => {
      widget.parentElement?.classList.remove(HIDDEN_CLASS);
    });
  };

  const variant = () => {
    getWidgets().forEach((widget) => {
      widget.parentElement?.classList.add(HIDDEN_CLASS);
    });
  };

  const reset = () => {
    getWidgets().forEach((widget) => {
      widget.parentElement?.classList.remove(HIDDEN_CLASS);
    });
  };

  observeWidgets();

  return { control, variant, reset };
})();
